
import { Navigate } from 'react-router-dom';
import { getAuthToken } from './utils/helper-functions';

const ProtectedRoutes = ({ children }) => {
    return getAuthToken() ? children : <Navigate to="/" />
}

export default ProtectedRoutes;
